// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__3Rzbg","progress":"LoadingSpinner_progress__3j219","icon":"LoadingSpinner_icon__3v3y-"};